import { Component, Input, Output, EventEmitter, Optional, Inject, OnInit } from '@angular/core';
import { EntityType, Entity } from 'src/app/models/entities.model';
import { FormGroup, FormControl } from '@angular/forms';
import { EntitySearchService } from '../../services/entity-search.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { trigger, transition, animate, keyframes } from '@angular/animations';
import * as kf from 'src/app/core/animations/keyframes';
import { BehaviorSubject } from 'rxjs';
import { CleanSubscriptions } from 'src/app/core/classes/clean-subcriptions';

export interface EntitySearchData {
  entityType?: EntityType;
  excludeIds?: number[];
  availableTypes?: EntityType[];
  autoSearch?: string;
  title?: string
}

export interface EntitySearchResult {
  selected: Entity;
}

const ALL_ENTITY_TYPES = [
  { id: 'any', value: 'Qualquer' },
  { id: 'users', value: 'Usuário' },
  { id: 'athletes', value: 'Atleta' },
  { id: 'clubs', value: 'Clube' },
  { id: 'contributors', value: 'Comissão Técnica' },
  { id: 'leagues', value: 'Liga' },
  { id: 'referees', value: 'Árbitro' }
];

@Component({
  selector: 'gio-entity-search-modal',
  templateUrl: './entity-search-modal.component.html',
  styleUrls: ['./entity-search-modal.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('searchbar', [

      // // fade out when destroyed. this could also be written as transition('void => *')
      transition(':enter', animate(500, keyframes(kf.slideInDown))),
      transition(':leave', animate(500, keyframes(kf.zoomOutRight)))
      // transition(':leave', animate(600, keyframes(kf.slideOutUp)))
    ]),
    trigger('cards', [

      // // fade out when destroyed. this could also be written as transition('void => *')
      transition(':enter', animate(500, keyframes(kf.slideInLeft))),
      transition(':leave', animate(500, keyframes(kf.slideOutRight)))
      // transition(':leave', animate(600, keyframes(kf.slideOutUp)))
    ])

  ]
})
export class EntitySearchModalComponent extends CleanSubscriptions implements OnInit {

  @Input()
  // tslint:disable-next-line: variable-name
  entityType: EntityType;

  @Input()
  excludeIds: number[];

  @Input()
  availableTypes;

  @Input()
  autoSearch: string;

  @Input()
  title: string;


  // tslint:disable-next-line: no-output-on-prefix
  @Output()
  selected: EventEmitter<Entity> = new EventEmitter();

  searching = '';
  _entities: Entity[];

  entityTypeCtrl = new FormControl('');

  form = new FormGroup({
    term: new FormControl(''),
    entityType: this.entityTypeCtrl
  });

  ENTITY_TYPES = [
    { id: 'any', value: 'Qualquer' },
    { id: 'users', value: 'Usuário' },
    { id: 'athletes', value: 'Atleta' },
    { id: 'clubs', value: 'Clube' },
    { id: 'contributors', value: 'Comissão Técnica' },
    { id: 'leagues', value: 'Liga' },
    { id: 'referees', value: 'Árbitro' }
  ];

  componentMethod: 'modal' | 'normal';

  searchVisible = true;
  searchTypeName = 'entidades';

  results$: BehaviorSubject<Entity[]> = new BehaviorSubject(null);

  constructor(
    private service: EntitySearchService,
    private dialogRef: MatDialogRef<EntitySearchModalComponent, EntitySearchResult>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: EntitySearchData
  ) { super(); }

  ngOnInit() {
    this.entityTypeCtrl.valueChanges.subscribe(entityType => {
      if (this._entities) {
        if (!entityType || entityType === 'any') {
          this.results$.next(this._entities);
        } else {
          this.results$.next(this._entities.filter(e => e.source_name === entityType));
        }
      }
    });

    if (this.dialogRef) {
      this.componentMethod = 'modal';
      if (this.data) {
        this.entityType = this.data.entityType;
        this.excludeIds = this.data.excludeIds;
        this.availableTypes = this.data.availableTypes;
        this.autoSearch = this.data.autoSearch;
        this.title = this.data.title;
      }
    } else {
      this.componentMethod = 'normal';
    }

    if (this.availableTypes && this.availableTypes.length > 0) {
      this.ENTITY_TYPES = ALL_ENTITY_TYPES.filter(et => this.availableTypes.find(at => et.id === at));
    } else {
      this.ENTITY_TYPES = [].concat(...ALL_ENTITY_TYPES);
    }

    if (this.ENTITY_TYPES.length == 1) {
      this.searchTypeName = this.ENTITY_TYPES[0].value.toLowerCase();
    } else {
      this.searchTypeName = 'entidade';
    }

    if (!this.entityType) {
      if (this.ENTITY_TYPES.length > -1) {
        this.entityType = this.ENTITY_TYPES[0].id as any;
      }
    }

    this.form.patchValue({
      entityType: this.entityType,
      term: this.autoSearch
    });

    if (this.autoSearch) {
      this.search();
    }

  }

  toggleVisibility() {
    setTimeout(() => {
      this.searchVisible = !this.searchVisible;
    }, 10);
  }

  search() {

    this.setSearchingTitle();
    let entityType = this.form.value.entityType || this.entityType;
    if (entityType === 'any') {
      entityType = null;
    }
    this.searching = 'Buscando entidades...';
    this.service.search(this.form.value.term, entityType)
      .subscribe(
        res => {
          let _res = res;
          if (this.excludeIds && this.excludeIds.length > 0 && res && res.length > 0) {
            _res = res.filter(r => !this.excludeIds.includes(r.id));
          }
          this._entities = _res;
          this.results$.next(this._entities);
          if (_res && _res.length > 0) {
            this.searchVisible = false;
          } else {
            this.searchVisible = true;
          }
          this.searching = '';
        },
        error => {
          this.searching = '';
          this.searchVisible = true;
        });
  }

  setSearchingTitle() {
    this.searching = `Procurando ${Entity.getEntityTypeName(this.entityType)}...`;
  }

  clicked(entity: Entity) {
    if (this.componentMethod === 'normal') {
      this.selected.emit(entity);
    } else {
      this.dialogRef.close({
        selected: entity
      });
    }
  }

  cancel() {
    if (this.componentMethod === 'normal') {
      this.selected.emit(null);
    } else {
      this.dialogRef.close({ selected: null });
    }

  }

}
